import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  doctors: [],
  doctorsNotAssigned: [],
  doctorById: {},
  doctorReport: {},
  selectedDoctor: false,
  doctorAssociatedWithStore: [],
  doctorDetails: "",
  billingDetail: {},
  rentDetails: {},
  doctorRecord: [],
  status: "idle",
  loading: false,
  error: null,
  isSidebarVisible: true,
  onboardingRequests: [],
};

const doctorSlice = createSlice({
  name: "doctor",
  initialState,
  reducers: {
    setDoctorDetail: (state, action) => {
      state.doctorDetails = action.payload;
      state.status = "succeeded";
    },
    createDoctor: (state, action) => {
      state.doctors.push(action.payload);
    },
    setDoctors: (state, action) => {
      state.doctors = action.payload;
      state.status = "succeeded";
    },
    setDoctorsAssociatedWithStore: (state, action) => {
      state.doctorAssociatedWithStore = action.payload;
      state.status = "succeeded";
    },
    setDoctorsNotAssigned: (state, action) => {
      state.doctorsNotAssigned = action.payload;
      state.status = "succeeded";
    },
    addDoctorToStore: (state, action) => {
      const { doctors } = state.doctorAssociatedWithStore[0];
      if (doctors) {
        state.doctorAssociatedWithStore[0].doctors = [
          ...doctors,
          action.payload,
        ];
        state.status = "succeeded";
      }
    },
    setDoctorById: (state, action) => {
      state.doctorById = action.payload;
      state.status = "succeeded";
    },
    setSearchDoctor: (state, action) => {
      state.selectedDoctor = action.payload;
      state.status = "succeeded";
    },
    setBillingDetail: (state, action) => {
      state.billingDetail = action.payload;
      state.status = "succeeded";
    },
    updateDoctor: (state, action) => {
      const { id, updatedData } = action.payload;
      const existingDoctor = state.doctors?.find(
        (doctor) => doctor?.DID === id
      );
      if (existingDoctor) {
        Object.assign(existingDoctor, updatedData);
      }
    },
    deleteDoctor: (state, action) => {
      state.doctors = state?.doctors?.filter(
        (doctor) => doctor?.DID !== action.payload
      );
    },
    unlinkDoctor: (state, action) => {
      state.doctorAssociatedWithStore = state?.doctorAssociatedWithStore?.map(
        (store) => ({
          ...store,
          doctors: store?.doctors?.filter(
            (doctor) => doctor?.DID !== action.payload
          ),
        })
      );
    },
    updateDoctorStatus: (state, action) => {
      const { newStatus } = action.payload;
      state.doctorDetails.doctor.currentDoctorStatus = newStatus;

      state.status = "succeeded";
    },
    setRentDetails: (state, action) => {
      state.rentDetails = action.payload;
      state.status = "succeeded";
    },
    setDoctorRecord: (state, action) => {
      state.doctorRecord = action.payload;
      state.status = "succeeded";
    },
    setDoctorReport: (state, action) => {
      state.doctorReport = action.payload;
      state.status = "succeeded";
    },
    setLoading: (state, action) => {
      state.status = "loading";
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.status = "failed";
    },
    setSidebarVisible: (state, action) => {
      state.isSidebarVisible = action.payload;
    },
    setOnboardingRequests: (state, action) => {
      state.onboardingRequests = action.payload || [];
      state.status = "succeeded";
    },
    updateOnboardingRequestInSlice: (state, action) => {
      const updated = action.payload;
      if (!state.onboardingRequests) {
        state.onboardingRequests = [];
      }
      state.onboardingRequests = state.onboardingRequests.map((req) => 
        req.id === updated.id ? updated : req
      );
    },
  },
});

export const {
  setDoctorDetail,
  createDoctor,
  setDoctors,
  setDoctorById,
  setDoctorsAssociatedWithStore,
  setDoctorsNotAssigned,
  addDoctorToStore,
  setBillingDetail,
  setSearchDoctor,
  updateDoctor,
  updateDoctorStatus,
  deleteDoctor,
  unlinkDoctor,
  setDoctorRecord,
  setRentDetails,
  setDoctorReport,
  setLoading,
  setError,
  setSidebarVisible,
  setOnboardingRequests,
  updateOnboardingRequestInSlice,
} = doctorSlice.actions;

export default doctorSlice.reducer;
